// @flow

import React, { type Node, useCallback } from 'react';
import { formatValueWithMask } from '@tectonics/components/input-mask';
import { normalizeCustomerDocument } from '@tectonics/prs/customer/normalize';
import { type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';

import { ErrorLabel } from '../../../../molecules/error-label';
import { FieldCustomerDocument } from '../field-customer-document';

export function FieldSouthAfricanDocument(): Node {
  const formatRaw = useCallback((rawValue: string): string => {
    return formatValueWithMask(rawValue, SOUTH_AFRICA_MASK);
  }, []);

  return (
    <FieldCustomerDocument
      inputData={{
        inputFieldName: 'southAfricanDocument',
        label: 'ID or passport',
        specDocumentName: 'field_south_african_document',
      }}
      mask={SOUTH_AFRICA_MASK}
      normalizer={normalizeCustomerDocument}
      type="text"
      formatRaw={formatRaw}
      validationErrorRenderer={ValidationErrorMessage}
    />
  );
}

type ValidationErrorMessageProps = {|
  validationError: UserInputValidationError,
|};

function ValidationErrorMessage({ validationError }: ValidationErrorMessageProps): Node {
  switch (validationError.id) {
    case 'server-error':
      return (
        <ErrorLabel>
          {serverErrorMessage(validationError.payload)}
        </ErrorLabel>
      );

    default:
      return <ErrorLabel>The number is invalid.</ErrorLabel>;
  }
}


const SOUTH_AFRICA_MASK = [
  /[A-Za-z0-9_]/, /[A-Za-z0-9_]/, /[A-Za-z0-9_]/, /[A-Za-z0-9_]/, /[A-Za-z0-9_]/,
  /[A-Za-z0-9_]/, /[A-Za-z0-9_]/, /[A-Za-z0-9_]/, /[A-Za-z0-9_]/, /[A-Za-z0-9_]/,
  /[A-Za-z0-9_]/, /[A-Za-z0-9_]/, /[A-Za-z0-9_]/,
];
